var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWestendInline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 766 506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M130.66,506H301.83L356.4,308.12c7.52-27.29,45.89-27.27,53.39,0L464.17,506H635L766,0H605.61l-41,200.81c-5.95,29.16-47,30-54,1.06L461.23,0H304.77L256.66,203.13c-6.86,29-48,28.44-54.06-.74l-14.44-69.25C172,55.55,104.1,0,25.48,0H0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWestendInline);
export default __webpack_public_path__ + "static/media/westend_inline.1bb84c910aef4a21a0aca11eb238e130.svg";
export { ForwardRef as ReactComponent };